import baseURL from '../common/axios';
class StockInFileUploadServices {
    insertStockWOFile(dataModel) {
        return baseURL.httpMSInventoryUrl.post("StockInFileUpload/Create", dataModel)
    }
    DeleteList(Id) {
        return baseURL.httpMSInventoryUrl.delete("StockInFileUpload/DeleteList?id=" + Id)
    }
    getStockInFileById(RefId) {
        return baseURL.httpMSInventoryUrl.get("StockInFileUpload/Get?RefId=" + RefId + "")
    }

}
export default new StockInFileUploadServices()